import AmexGDAOffersApplyNow from './AmexGDAOffersApplyNow';

export default AmexGDAOffersApplyNow;
